/* F.G. Edwards store calendar and header store-hours widget.
   Data comes from window.FGStoreConfig, written by snippets/fg-store-hours.liquid from the theme settings. */
/* Store calendar, shared by the header widget and the homepage (assets/fg-home.js).
   Closed days are computed each year: Québec public holidays, with the store's own choices
   (Easter Monday is the Easter closure, Good Friday is a normal day, plus December 26 and January 2).
   One-off closures come from Theme settings > FG Edwards Settings > Store Hours. */
window.FGStoreCalendar = window.FGStoreCalendar || (function () {
  var extra = String((window.FGStoreConfig && window.FGStoreConfig.closures) || '').split(/[\s,;]+/).filter(function (s) { return /^\d{4}-\d{2}-\d{2}$/.test(s); });
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(y, m, d) { var t = new Date(Date.UTC(y, m - 1, d)); return t.getUTCFullYear() + '-' + pad(t.getUTCMonth() + 1) + '-' + pad(t.getUTCDate()); }
  function utc(s) { var p = s.split('-'); return Date.UTC(+p[0], +p[1] - 1, +p[2]); }
  function addDays(s, n) { var t = new Date(utc(s) + n * 864e5); return iso(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate()); }
  function weekday(s) { return new Date(utc(s)).getUTCDay(); }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    return iso(y, Math.floor((h + l - 7 * m + 114) / 31), ((h + l - 7 * m + 114) % 31) + 1);
  }
  function nth(y, m, wd, n) { var f = iso(y, m, 1); return addDays(f, ((wd - weekday(f) + 7) % 7) + 7 * (n - 1)); }
  var cache = {};
  function closures(y) {
    if (cache[y]) return cache[y];
    var p = iso(y, 5, 24);
    while (weekday(p) !== 1) p = addDays(p, -1);
    return (cache[y] = [
      { date: iso(y, 1, 1), fr: "jour de l'An", en: "New Year's Day" },
      { date: iso(y, 1, 2), fr: "lendemain du jour de l'An", en: 'January 2' },
      { date: addDays(easter(y), 1), fr: 'lundi de Pâques', en: 'Easter Monday' },
      { date: p, fr: 'Journée nationale des patriotes', en: 'National Patriots’ Day' },
      { date: iso(y, 6, 24), fr: 'Fête nationale', en: 'Saint-Jean-Baptiste Day' },
      { date: iso(y, 7, 1), fr: 'fête du Canada', en: 'Canada Day' },
      { date: nth(y, 9, 1, 1), fr: 'fête du Travail', en: 'Labour Day' },
      { date: nth(y, 10, 1, 2), fr: 'Action de grâce', en: 'Thanksgiving' },
      { date: iso(y, 12, 25), fr: 'Noël', en: 'Christmas' },
      { date: iso(y, 12, 26), fr: 'lendemain de Noël', en: 'Boxing Day' }
    ]);
  }
  /* Returns null when the store opens normally that day, otherwise { fr, en } naming the closure. */
  function closure(s) {
    var list = closures(+s.slice(0, 4));
    for (var i = 0; i < list.length; i++) if (list[i].date === s) return list[i];
    if (extra.indexOf(s) > -1) return { date: s, fr: 'fermeture exceptionnelle', en: 'special closure' };
    return null;
  }
  function today() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { var d = new Date(); return iso(d.getFullYear(), d.getMonth() + 1, d.getDate()); }
  }
  return { closure: closure, closures: closures, today: today, addDays: addDays, weekday: weekday };
})();

/* The strip above the header (sections/announcement-bar.liquid): a store closure in the next few days comes
   first; then the dated event the section wrote; then, for a visitor whose postal code is known on this
   device, the next local delivery; otherwise the section's standing sentence stays. */
(function () {
  var strip = document.querySelector('[data-fg-strip]');
  var cal = window.FGStoreCalendar;
  if (!strip || !cal) return;
  var line = strip.querySelector('[data-fg-strip-line]');
  var text = strip.querySelector('[data-fg-strip-text]');
  if (!line || !text) return;
  var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  function fmt(s, opts) { var p = s.split('-'); return new Intl.DateTimeFormat(en ? 'en-CA' : 'fr-CA', opts).format(new Date(+p[0], +p[1] - 1, +p[2])); }
  function say(kind, html, href) {
    text.innerHTML = html;
    strip.setAttribute('data-kind', kind);
    strip.classList.toggle('is-closure', kind === 'closure');
    if (href && line.tagName === 'A') line.setAttribute('href', href);
    else if (href) {
      var a = document.createElement('a');
      a.className = line.className; a.setAttribute('data-fg-strip-line', ''); a.href = href;
      while (line.firstChild) a.appendChild(line.firstChild);
      line.parentNode.replaceChild(a, line); line = a;
    }
  }
  var today = cal.today();
  var span = parseInt(strip.getAttribute('data-closure-days') || '0', 10);
  for (var i = 0; span > 0 && i <= span; i++) {
    var d = cal.addDays(today, i), c = cal.closure(d);
    if (!c) continue;
    var name = en ? c.en : c.fr;
    var when = fmt(d, { weekday: 'long', day: 'numeric', month: 'long' });
    say('closure', i === 0
      ? (en ? '<b>Our stores are closed today</b> (' + name + '). Online orders stay open.' : '<b>Nos magasins sont fermés aujourd\u2019hui</b> (' + name + '). La commande en ligne reste ouverte.')
      : (en ? '<b>Our stores will be closed ' + when + '</b> (' + name + ').' : '<b>Nos magasins seront fermés ' + when + '</b> (' + name + ').'),
      strip.getAttribute('data-closure-link'));
    break;
  }
  if (strip.getAttribute('data-kind') === 'standing' && strip.hasAttribute('data-delivery')) {
    var route = null;
    try { route = JSON.parse(localStorage.getItem('fgh_route') || 'null'); } catch (e) {}
    if (route && Array.isArray(route.days) && route.days.length) {
      for (var j = 1; j <= 35; j++) {
        var date = cal.addDays(today, j);
        if (route.days.indexOf(cal.weekday(date)) < 0 || cal.closure(date)) continue;
        var day = fmt(date, { weekday: 'long', day: 'numeric', month: 'long' });
        var cut = j === 1
          ? (en ? 'Order by midnight tonight.' : 'Commandez d\u2019ici minuit ce soir.')
          : (en ? 'Order by midnight ' + fmt(cal.addDays(date, -1), { weekday: 'long' }) + '.' : 'Commandez d\u2019ici ' + fmt(cal.addDays(date, -1), { weekday: 'long' }) + ' minuit.');
        var fsa = route.fsa ? ' (' + String(route.fsa).replace(/[^A-Za-z0-9]/g, '').slice(0, 3).toUpperCase() + ')' : '';
        say('delivery', (en ? '<b>Next local delivery' + fsa + ': ' + day + '.</b> ' : '<b>Prochaine livraison locale' + fsa + '\u00a0: ' + day + '.</b> ') + cut, strip.getAttribute('data-delivery-link'));
        break;
      }
    }
  }
  strip.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('a')) return;
    var data = { kind: strip.getAttribute('data-kind') };
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('fg_strip_click', data); } catch (err) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'fg_strip_click', kind: data.kind }); } catch (err) {}
  });
})();

(function() {
  'use strict';

  var cfg = window.FGStoreConfig || { locale: 'fr', t: {}, hours: { 'west-brome': [], 'bedford': [] } };
  var root = document.querySelector('[data-fg-hours]');
  if (!root) return;

  // Prevent double-init
  if (root.dataset.fgInit === '1') return;
  root.dataset.fgInit = '1';

  var toggle = root.querySelector('[data-fg-hours-toggle]');
  var dropdown = root.querySelector('[data-fg-hours-dropdown]');
  var closeBtn = root.querySelector('[data-fg-hours-close]');
  var dot = root.querySelector('[data-fg-hours-dot]');
  var text = root.querySelector('[data-fg-hours-text]');
  var storeNameEl = root.querySelector('[data-fg-hours-store-name]');
  var tabs = root.querySelectorAll('[data-fg-hours-tab]');
  var panels = root.querySelectorAll('[data-fg-hours-panel]');

  var defaultStore = root.getAttribute('data-default-store') || 'West Brome';
  var currentStore = defaultStore.toLowerCase().replace(/\s+/g, '-');

  // Translations: the locale strings carry a time placeholder
  // in double curly braces, or in single braces in the fallbacks below
  var translations = {
    open: cfg.t.open || 'Open',
    closed: cfg.t.closed || 'Closed',
    closesAt: cfg.t.closesAt || 'Ferme à {time}',
    opensAt: cfg.t.opensAt || 'Ouvre à {time}'
  };

  // Store hours configuration
  var storeHours = {
    'west-brome': {
      name: 'West Brome',
      0: parseHours(cfg.hours['west-brome'][0]),
      1: parseHours(cfg.hours['west-brome'][1]),
      2: parseHours(cfg.hours['west-brome'][2]),
      3: parseHours(cfg.hours['west-brome'][3]),
      4: parseHours(cfg.hours['west-brome'][4]),
      5: parseHours(cfg.hours['west-brome'][5]),
      6: parseHours(cfg.hours['west-brome'][6])
    },
    'bedford': {
      name: 'Bedford',
      0: parseHours(cfg.hours['bedford'][0]),
      1: parseHours(cfg.hours['bedford'][1]),
      2: parseHours(cfg.hours['bedford'][2]),
      3: parseHours(cfg.hours['bedford'][3]),
      4: parseHours(cfg.hours['bedford'][4]),
      5: parseHours(cfg.hours['bedford'][5]),
      6: parseHours(cfg.hours['bedford'][6])
    }
  };

  function parseHours(hoursStr) {
    var closedPatterns = ['fermé', 'closed', '-'];
    if (!hoursStr || closedPatterns.some(function(p) { return hoursStr.toLowerCase().trim() === p; })) {
      return null;
    }
    var parts = hoursStr.split(/\s*[-–]\s*/);
    if (parts.length !== 2) return null;
    var open = parseTime(parts[0]);
    var close = parseTime(parts[1]);
    if (open === null || close === null) return null;
    return { open: open, close: close, openStr: parts[0].trim(), closeStr: parts[1].trim() };
  }

  function parseTime(timeStr) {
    if (!timeStr) return null;
    timeStr = timeStr.trim().toLowerCase();
    var isPM = timeStr.includes('pm');
    var isAM = timeStr.includes('am');
    timeStr = timeStr.replace(/[ap]m/gi, '').trim();
    var parts = timeStr.split(':');
    var hours = parseInt(parts[0], 10);
    var minutes = parts[1] ? parseInt(parts[1], 10) : 0;
    if (isNaN(hours)) return null;
    if (isPM && hours < 12) hours += 12;
    if (isAM && hours === 12) hours = 0;
    return hours * 60 + minutes;
  }

  function formatTime(mins) {
    var h = Math.floor(mins / 60);
    var m = mins % 60;
    return h + ':' + (m < 10 ? '0' : '') + m;
  }

  // Québec style in French ("8 h 30", "17 h"), "8:30" in English
  function localTime(mins) {
    if (cfg.locale === 'en') return formatTime(mins);
    var h = Math.floor(mins / 60), m = mins % 60;
    return h + ' h' + (m ? ' ' + (m < 10 ? '0' : '') + m : '');
  }

  function getCurrentMinutes() {
    var now = new Date();
    try {
      var options = { timeZone: 'America/Toronto', hour: 'numeric', minute: 'numeric', hour12: false };
      var timeStr = now.toLocaleString('en-US', options);
      var parts = timeStr.split(':');
      return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
    } catch (e) {
      return now.getHours() * 60 + now.getMinutes();
    }
  }

  function getCurrentDay() {
    var now = new Date();
    try {
      var options = { timeZone: 'America/Toronto', weekday: 'short' };
      var dayStr = now.toLocaleString('en-US', options);
      var days = { 'Sun': 0, 'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6 };
      return days[dayStr] !== undefined ? days[dayStr] : now.getDay();
    } catch (e) {
      return now.getDay();
    }
  }

  function isStoreOpen(store) {
    var cal = window.FGStoreCalendar;
    if (cal && cal.closure(cal.today())) return false;
    var day = getCurrentDay();
    var hours = storeHours[store] && storeHours[store][day];
    if (!hours) return false;
    var currentMins = getCurrentMinutes();
    return currentMins >= hours.open && currentMins < hours.close;
  }

  function getStoreHoursToday(store) {
    var day = getCurrentDay();
    return storeHours[store] && storeHours[store][day];
  }

  function updateStatus() {
    var isOpen = isStoreOpen(currentStore);
    var hours = getStoreHoursToday(currentStore);
    var storeName = storeHours[currentStore] ? storeHours[currentStore].name : defaultStore;

    // Update store name display
    if (storeNameEl) {
      storeNameEl.textContent = storeName;
    }

    // Update dot
    dot.classList.remove('is-open', 'is-closed');
    dot.classList.add(isOpen ? 'is-open' : 'is-closed');

    // Update text
    text.classList.remove('is-open', 'is-closed');
    var cal = window.FGStoreCalendar;
    var closedToday = cal && cal.closure(cal.today());
    if (isOpen && hours) {
      text.classList.add('is-open');
      var closeTime = localTime(hours.close);
      // Put the time in place of the placeholder, in either form
      text.textContent = translations.closesAt
        .replace(/\{\{\s*time\s*\}\}/g, closeTime)
        .replace(/\{time\}/g, closeTime);
    } else if (hours && !closedToday && getCurrentMinutes() < hours.open) {
      // Before opening: say when, not just "Fermé"
      text.classList.add('is-closed');
      var openTime = localTime(hours.open);
      text.textContent = translations.opensAt
        .replace(/\{\{\s*time\s*\}\}/g, openTime)
        .replace(/\{time\}/g, openTime);
    } else {
      /* After closing, or on a closed day: say when the store opens next, not just "Fermé" (docs/header/05) */
      text.classList.add('is-closed');
      var next = '';
      if (cal) {
        var en = cfg.locale === 'en';
        var names = en ? ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] : ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
        for (var d = 1; d <= 7 && !next; d++) {
          var date = cal.addDays(cal.today(), d);
          var h = storeHours[currentStore] && storeHours[currentStore][cal.weekday(date)];
          if (!h || cal.closure(date)) continue;
          var when = d === 1 ? (en ? 'tomorrow' : 'demain') : names[cal.weekday(date)];
          next = (en ? 'Opens ' + when + ' at ' : 'Ouvre ' + when + ' à ') + localTime(h.open);
        }
      }
      text.textContent = next || translations.closed;
    }

    // Highlight today's row
    var day = getCurrentDay();
    panels.forEach(function(panel) {
      var dayRows = panel.querySelectorAll('[data-day]');
      dayRows.forEach(function(row) {
        row.classList.remove('is-today');
        if (parseInt(row.dataset.day, 10) === day) {
          row.classList.add('is-today');
        }
      });
    });
  }

  function switchTab(newStore) {
    currentStore = newStore;

    tabs.forEach(function(tab) {
      var isActive = tab.dataset.fgHoursTab === newStore;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function(panel) {
      var isActive = panel.dataset.fgHoursPanel === newStore;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    // Save preference
    try {
      localStorage.setItem('fg_preferred_store', newStore);
    } catch (e) {}

    // Dispatch event for other components (with flag to prevent loop)
    document.dispatchEvent(new CustomEvent('fg-store-change', {
      detail: { store: storeHours[newStore] ? storeHours[newStore].name : newStore, _fromStoreHours: true }
    }));

    updateStatus();
  }

  function openDropdown() {
    dropdown.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');

    // Position dropdown below toggle - works on iOS
    // Only set top position on mobile where we use fixed positioning
    var isMobile = window.innerWidth <= 989;

    if (isMobile) {
      var headerSection = document.querySelector('.shopify-section-header, #shopify-section-header, [id^="shopify-section-header"]');
      var topPos = 120; // Fallback value

      if (headerSection) {
        var headerRect = headerSection.getBoundingClientRect();
        topPos = headerRect.bottom + 8;
      } else {
        var toggleRect = toggle.getBoundingClientRect();
        topPos = toggleRect.bottom + 8;
      }

      dropdown.style.top = topPos + 'px';
    }
  }

  function closeDropdown() {
    dropdown.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function toggleDropdown() {
    if (dropdown.hidden) {
      openDropdown();
    } else {
      closeDropdown();
    }
  }

  // Click handler for toggle
  toggle.addEventListener('click', function(e) {
    toggleDropdown();
  });

  // Click handler for close button
  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      closeDropdown();
    });
  }

  // Tab click handlers
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      switchTab(tab.dataset.fgHoursTab);
    });
  });

  // Listen for store changes from fg-fastbuy (but not our own events)
  document.addEventListener('fg-store-change', function(e) {
    // Skip if this event was dispatched by us (check a custom flag)
    if (e.detail && e.detail._fromStoreHours) return;
    if (e.detail && e.detail.store) {
      var newStore = e.detail.store.toLowerCase().replace(/\s+/g, '-');
      if (storeHours[newStore] && newStore !== currentStore) {
        // Update without dispatching another event
        currentStore = newStore;
        tabs.forEach(function(tab) {
          var isActive = tab.dataset.fgHoursTab === newStore;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach(function(panel) {
          var isActive = panel.dataset.fgHoursPanel === newStore;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
        try { localStorage.setItem('fg_preferred_store', newStore); } catch (e) {}
        updateStatus();
      }
    }
  });

  // Listen to fg-fastbuy store selector changes
  var fgStoreSelect = document.querySelector('[data-fg-store]');
  if (fgStoreSelect) {
    fgStoreSelect.addEventListener('change', function() {
      var newStore = fgStoreSelect.value.toLowerCase().replace(/\s+/g, '-');
      if (storeHours[newStore]) {
        switchTab(newStore);
      }
    });
  }

  // Check for saved preference
  try {
    var savedStore = localStorage.getItem('fg_preferred_store');
    if (savedStore && storeHours[savedStore]) {
      currentStore = savedStore;
      switchTab(savedStore);
    }
  } catch (e) {}

  // Initial update
  updateStatus();

  // Update every minute
  setInterval(updateStatus, 60000);

})();
